// 10MB
export const MaxFileSize = 10000000;
export const InvalidFilenames = ['crossdomain.xml', 'clientaccesspolicy.xml'];
